<template>
  <div>
    <template>
      <VueFileAgent
        ref="vueFileAgent"
        v-model="fileRecords"
        :theme="'list'"
        :multiple="true"
        :deletable="true"
        :editable="true"
        :linkable="true"
        :sortable="isSortable"
        :accept="'application/pdf'"
        :help-text="'Choisissez les fichiers pdf'"
        :error-text="{
          type: 'Type de fichier invalide. Seuls les fichiers PDF sont autorisés !',
        }"
        @sort="filesOrder()"
        @select="filesSelected($event)"
        @beforedelete="onBeforeDelete($event)"
        @delete="fileDeleted($event)"
        @rename="fileRename($event)"
      ></VueFileAgent>
    </template>
    <div>
      <b-form-checkbox
        v-model="isSortable"
        class="mt-1"
        :disabled="!fileRecords.length"
        :value="true"
        :unchecked-value="false"
      >
        <div class="ml-2">
          <span v-if="!isSortable">Activer ordre</span>
          <span v-else>Désactiver ordre</span>
        </div>
      </b-form-checkbox>
    </div>
  </div>
</template>

<script>
import links from "@/links/links";
import MediaMW from "@/middlewares/Media";
import MeetingResolutionMW from "@/middlewares/MeetingResolution";
export default {
  props: {
    resolution: {
      type: Object,
      required: true,
    },
    resolutionId: {
      type: String,
      default: "",
    },
    meetingResolutionId: {
      type: String,
      default: "",
    },
    isInMeetingStart: {
      type: Boolean,
      default: false,
    },
    isInMeeting: {
      type: Boolean,
      default: false,
    },
    keyId: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      links: links,
      fileRecords: [],
      isSortable: false,
    };
  },
  created() {
    // Create fileRecords for upload zone with existing media
    if (this.resolution.media && this.resolution.media.length > 0) {
      this.resolution.media.forEach(media => {
        this.createPdfFileRecord(media);
      });
      // Don't sort if some of the media is new
      let isMediaNew = this.$_.find(this.resolution.media, media => {
        return media.isNew;
      });
      if (isMediaNew === undefined) {
        this.fileRecords.sort((a, b) => (a.media.position > b.media.position ? 1 : -1));
      }
    }
    this.updateFileRecords();
  },
  methods: {
    filesOrder() {
      let media = [];
      this.fileRecords.forEach(file => {
        media.push(file.media);
      });
      this.updateFileRecords();
      MediaMW.MEDIA_UPDATE_PDF_POSITION({ orderMediaPosition: media });
    },
    async filesSelected(filesSelected) {
      if (filesSelected.length > 0) {
        let validTypeFiles = filesSelected.filter(file => file.error === false);
        if (validTypeFiles.length > 0) {
          let filesToBeUploaded = [];
          validTypeFiles.forEach(file => {
            filesToBeUploaded.push(file.file);
          });
          await MediaMW.MEDIA_CHECK_PDF_FORMAT(
            filesToBeUploaded,
            this.isInMeeting ? "meeting_resolution" : "resolution",
            this.isInMeeting ? this.meetingResolutionId : this.resolutionId
          ).then(async res => {
            if (res.response.data.invalidFiles.length > 0) {
              let invalidFilesErrorMessage = "";
              res.response.data.invalidFiles.forEach(file => {
                this.fileRecords = this.fileRecords.filter(f => f.file.name !== file.name + ".pdf");
                invalidFilesErrorMessage +=
                  "<small><b>" +
                  file.name +
                  ".pdf</b> ce fichier a un format différent du A4 !</small> </br>";
              });
              this.$swal({
                icon: "error",
                title: "Erreur de téléchargement PDF !",
                html: invalidFilesErrorMessage,
              });
            }
            if (res.response.data.validFiles.length > 0) {
              res.response.data.validFiles.forEach(file => {
                // Filter the files added automatically and add them manually in createPdfFileRecord
                this.fileRecords = this.fileRecords.filter(f => f.media != undefined);
                this.createPdfFileRecord(file, true);
              });
              this.updateFileRecords();
            }
            // ???: ??
            if (this.isInMeetingStart) await MeetingResolutionMW.GET(this.meetingResolutionId);
          });
        }
      }
    },
    onBeforeDelete(fileRecord) {
      this.$swal(this.alertQuestion())
        .then(res => {
          if (res.value) {
            this.$refs.vueFileAgent.deleteFileRecord(fileRecord); // will trigger 'delete' event
          }
        })
        .catch(err => {
          console.log("err", err);
          this.$swal(this.alertError());
        });
    },
    fileDeleted(fileRecord) {
      this.DELETE_MEDIA(fileRecord.media);
      this.deleteFileRecord(fileRecord);
    },
    DELETE_MEDIA(media) {
      MediaMW.DELETE(media).then(() => {
        // remove media from local resolution
        if (this.resolution.media) {
          this.resolution.media.splice(
            this.resolution.media.findIndex(item => item.id == media.id),
            1
          );
        }
      });
    },
    fileRename(fileRecord) {
      fileRecord.media.label = fileRecord.name().split(".")[0];
      MediaMW.PUT(fileRecord.media).catch(err => {
        const { alertErrorAndReport } = useAlerts();
        alertErrorAndReport(
          err,
          "Nous avons détecté une erreur de connexion",
          "La dernière modification n'a pas pu être enregistrée, veuillez vérifier votre connexion Internet."
        );
      });
      this.updateFileRecords();
    },
    createPdfFileRecord(media, isNew = false) {
      let mediaName = media.label ? media.label : media.name || media.filename;
      let defaultRecord = {};
      var file = new File([0], mediaName + ".pdf", {
        type: "application/pdf",
      });
      defaultRecord["media"] = media;
      defaultRecord["file"] = file;
      if (media.file_path) {
        defaultRecord["url"] = links.API_WEB_APP_MEDIA_LINK(media.file_path);
      }
      if (isNew) {
        defaultRecord.media.isNew = isNew;
      }
      if (this.keyId) {
        defaultRecord.media.keyId = this.keyId;
      }
      if (this.resolutionId) {
        defaultRecord.media.resolution_id = this.resolutionId;
      }
      if (this.meetingResolutionId) {
        defaultRecord.media.meeting_has_resolution_id = this.meetingResolutionId;
      }
      this.fileRecords.push(defaultRecord);
    },
    updateFileRecords() {
      this.$emit("updateFileRecords", this.fileRecords);
    },
    deleteFileRecord(fileRecord) {
      this.$emit("deleteFileRecord", fileRecord);
    },
  },
};
</script>
